import * as React from 'react';
import { observer } from 'mobx-react';
import { UitkErrorSummary } from 'uitk-react-error-summary';
import { UitkSpacing } from 'uitk-react-spacing';

const info = {
  missing_age_of_child: 'Please provide the ages of children.',
  max_traveler:
    'We are only able to book between 1 and 5 travelers. Please adjust the number of travelers for your search.',
};

export interface InfoMessageProps {
  messageKey: string;
  showInfoMessage: boolean;
}
export const InfoMessage = observer(({ messageKey, showInfoMessage }: InfoMessageProps) => {
  return (
    <div style={{ display: showInfoMessage ? 'block' : 'none' }}>
      <UitkSpacing padding={{ blockstart: 'two' }}>
        <UitkErrorSummary heading={`${info[messageKey]}`} />
      </UitkSpacing>
    </div>
  );
});
